import type { Env } from "./enums";

import { canUseDOM } from "replo-utils/dom/misc";

export const isLocalhost = (): boolean => {
  if (!canUseDOM) {
    return false;
  }
  // NOTE (Chance 2024-05-31): Global window should be fine for this check
  return window.location.hostname === "localhost";
};

export const getEnv = (): Env => {
  const nodeEnv = process.env.NODE_ENV;

  if (nodeEnv === "production") {
    return "production";
  }

  return "dev";
};
